define('presentation/common/callDetails/presentationObjects/callDetailStepPresentationObject',[],function() {
    return function(){
        const self = this;

        self.dateTimeStarted = null;
        self.lastStep = null;
        self.type = null;
        self.phoneNumber = null;
        self.otherPartyPhoneNumber = null;
        self.otherPartyLocation = null;
        self.accountVoicePromptId = null;
        self.name = null;
        self.metadata = null;
        self.audioUrl = null;
        self.durationInSeconds = null;
        self.location = null;
        self.systemAudioClipId = null;
        self.phoneConnectorId = null;
        self.phoneNumberName = null;
        self.userId = null;
        self.exitConditionText = null;
        self.groupId = null;
        self.groupName = null;
        self.forwardingNumberId = null;
        self.forwardingNumberName = null;
        self.autoAttendantId = null;
        self.autoAttendantName = null;
        self.navigationNames = null;
        self.voicemailBoxId = null;
        self.liveReceptionistScriptId = null;
    };
});

